module.exports = __webpack_public_path__ + "img/deselect-icon.e302ba0d.png";